import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
  })
export class AuthenticationService {
  //  apiUrl="http://localhost:3003";
     apiUrl = "https://lexipackghana.com:3003";

  constructor(private http: HttpClient, private router: Router) { }

  isUSerLogin(userId:any){
    if (localStorage.getItem('token')) {
      let token:any = localStorage.getItem('token');
      let decode:any = jwtDecode(token)
      var dateNow = Date.now()/1000;
      console.log(decode.exp < dateNow)
      if(decode.exp < dateNow)
      {
        return false;
      }
      else
       return true
    } else {
      return false;
    }
  }
  getUserData(){
    if (localStorage.getItem('token')) {
      let token:any = localStorage.getItem('token');
      let decode:any = jwtDecode(token);
       return decode
    } else {
      return {};
    }
  }
  signin(payload:any) {
    return this.http.post(this.apiUrl+'/api/auth/login',payload);
  }
// Helper function to handle API calls that might encounter expired token
handleApiError(error: any) {
  if (error.status === 401) {
    // Token expired or unauthorized, redirect to login page
    alert('Your session has expired. Please log in again.');
    localStorage.clear(); // Optionally clear local storage
    this.router.navigateByUrl('/login').then(() => {
      window.location.reload();
    });
    } else {
    console.error('API Error:', error);
  }
}
  addUser(data:any){
    return this.http.post(this.apiUrl+'/api/addUser',data);
  }

  updateUser(id:any,data:any){
    return this.http.put(this.apiUrl+'/api/updateUser/'+id,data);
  }
  updateUserList(userId:any, updatedData: any){
    return this.http.put(this.apiUrl+'/api/updateUserList/'+userId,updatedData);
  }
  getUser(){
    return this.http.get(this.apiUrl+'/api/getUser');
  }
  getUserProfile(id:any){
    return this.http.get(this.apiUrl+'/api/getUser/'+id)
  }
  deleteUser(id: string) {
    return this.http.delete(this.apiUrl + '/api/deleteUserById/' + id);
  }

  salesUser() {
  return this.http.get(this.apiUrl + '/api/salesUser');
}

createUser() {
  return this.http.get(this.apiUrl + '/api/createUser');
}

}